import state from './BalanceOfPayment/states'
import mutations from './BalanceOfPayment/mutations'
import actions from './BalanceOfPayment/actions'
import getters from './BalanceOfPayment/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
